import { render, staticRenderFns } from "./FormatDate.vue?vue&type=template&id=10ad4710&scoped=true&"
import script from "./FormatDate.vue?vue&type=script&lang=js&"
export * from "./FormatDate.vue?vue&type=script&lang=js&"
import style0 from "./FormatDate.vue?vue&type=style&index=0&id=10ad4710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad4710",
  null
  
)

export default component.exports